import { render, staticRenderFns } from "./AmazeUserGroups.vue?vue&type=template&id=7358d930&scoped=true"
import script from "./AmazeUserGroups.vue?vue&type=script&lang=js"
export * from "./AmazeUserGroups.vue?vue&type=script&lang=js"
import style0 from "./AmazeUserGroups.vue?vue&type=style&index=0&id=7358d930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7358d930",
  null
  
)

export default component.exports